import React, { useEffect, useState } from "react";
import * as styles from "./CheckboxHelper.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";

const CheckboxHelper = ({ id, name, label, defaultValue = false, onChange, field, form, children, disabled }) => {
	const [checked, setChecked] = useState(field ? field.value : defaultValue);
	const checkboxHelperClassName = classNames({
		[styles["checkbox-helper"]]: true,
	});

	useEffect(() => {
		setChecked(defaultValue);
	}, [defaultValue]);

	const fieldName = field ? field.name : name;
	const fieldID = id || fieldName;

	return (
		<div className={checkboxHelperClassName}>
			{children({
				isActive: checked,
				fieldID,
				label,
			})}
			<input
				type={"checkbox"}
				id={fieldID}
				name={fieldName}
				checked={checked || false}
				disabled={disabled}
				onChange={(event) => {
					if (onChange) onChange(event);
					if (form) form.setFieldValue(field.name, event.currentTarget.checked);
					setChecked(event.currentTarget.checked);
				}}
			/>
		</div>
	);
};

CheckboxHelper.propTypes = {
	id: PropTypes.string,
	name: PropTypes.string.isRequired,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	defaultValue: PropTypes.any,
	hasError: PropTypes.bool,
	onChange: PropTypes.func,
	children: PropTypes.func,
	disabled: PropTypes.bool,
	className: PropTypes.string,
};

export default CheckboxHelper;
